import { createSlice } from "@reduxjs/toolkit";

export const editPartnerFeeSlice = createSlice({
	name: "editPartnerFee",
	initialState: {
		lockerTypesList: [],
		doorSizesList: [],
		partnerTypesList: [],
		partnerDropoffFees: [],
		partnerShipoutFees: [],
		// For Pickup
		addDataItem: [],
		// For Shipout
		addShipoutData: [],
	},
	reducers: {
		handleChangeLockerTypeAndUserTypeReducer: (state, actions) => {
			const { name, value } = actions.payload;
			const tempVar = { ...state.lockerTypeAndUserType };
			tempVar[name] = value;
			// Lists
			const tempData = [...state.addDataItem];
			const tempShipoutData = [...state.addShipoutData];

			tempData.forEach((element, index) => {
				tempData[index][name] = value;
			});
			tempShipoutData.forEach((element, index) => {
				tempShipoutData[index][name] = value;
			});
			state.lockerTypeAndUserType = tempVar;
			state.addDataItem = tempData;
			state.addShipoutData = tempShipoutData;
		},
		setPartnerTypeList: (state, actions) => {
			state.partnerTypesList = actions.payload;
		},
		setLockerTypeList: (state, actions) => {
			state.lockerTypesList = actions.payload;
		},
		setDoorSizesList: (state, actions) => {
			state.doorSizesList = actions.payload;
		},
		setPartnerDropoffFees: (state, actions) => {
			state.partnerDropoffFees = actions.payload;
		},
		setPartnerShipoutFees: (state, actions) => {
			state.partnerShipoutFees = actions.payload;
		},
		//For Pickup
		handleAddDataItemReducer: (state, actions) => {
			let tempVar = [...state.addDataItem];
			tempVar.push(actions.payload);
			state.addDataItem = tempVar;
		},
		handleEditAddedDataReducer: (state, actions) => {
			const { name, value, id } = actions.payload;
			console.log({ name, value, id });
			const tempVar = [...state.addDataItem];
			if (id && name) {
				if (
					name === "initialFee" ||
					name === "excessFeePerInc" ||
					name === "maxOverstayCharge"
				) {
					if (parseFloat(value) >= 0 && parseFloat(value) <= 1000000000.0) {
						tempVar[id][name] = parseFloat(value);
					} else if (value === "") {
						tempVar[id][name] = value;
					}
				} else if (name === "incByHours") {
					if (value >= 0 && value <= 720) {
						tempVar[id][name] = value;
					}
				} else if (name === "initialFreeHours") {
					if (parseInt(value) >= 1 && parseInt(value) <= 720) {
						tempVar[id][name] = value;
					}
				} else {
					tempVar[id][name] = value;
				}
			}
		},
		handleEditDataReducer: (state, actions) => {
			const { name, value, id } = actions.payload;
			const tempVar = [...state.partnerDropoffFees];
			if (id && name) {
				if (
					name === "initialFee" ||
					name === "excessFeePerInc" ||
					name === "maxOverstayCharge"
				) {
					if (parseFloat(value) >= 0 && parseFloat(value) <= 1000000000.0) {
						tempVar[id][name] = parseFloat(value);
					} else if (value === "") {
						tempVar[id][name] = value;
					}
				} else if (name === "incByHours") {
					if (value >= 0 && value <= 720) {
						tempVar[id][name] = value;
					}
				} else if (name === "addInitialFreeHours") {
					if (value >= 1 && value <= 720) {
						tempVar[id][name] = value;
					}
				} else {
					tempVar[id][name] = value;
				}
			}
		},
		// For Shipout
		handleShipoutAddDataItemReducer: (state, actions) => {
			let tempVar = [...state.addShipoutData];
			tempVar.push(actions.payload);
			state.addShipoutData = tempVar;
		},
		handleShipoutEditAddedDataReducer: (state, actions) => {
			const { name, value, id } = actions.payload;
			const tempVar = [...state.addShipoutData];
			if (id && name) {
				if (name === "incByHours") {
					if (value >= 0 && value <= 720) {
						tempVar[id][name] = value;
					}
				} else if (name === "addInitialFreeHours") {
					if (value >= 1 && value <= 720) {
						tempVar[id][name] = value;
					}
				} else {
					tempVar[id][name] = value;
				}
			}
		},
		handleShipoutEditDataReducer: (state, actions) => {
			const { name, value, id } = actions.payload;
			const tempVar = [...state.partnerShipoutFees];
			if (id && name) {
				if (name === "incByHours") {
					if (value >= 0 && value <= 720) {
						tempVar[id][name] = value;
					}
				} else if (name === "addInitialFreeHours") {
					if (value >= 1 && value <= 720) {
						tempVar[id][name] = value;
					}
				} else {
					tempVar[id][name] = value;
				}
			}
		},
		handelCancelChagesReducer: (state) => {
			state.lockerTypeAndUserType = {
				lockerTypeId: "-1",
				userTypeId: "-1",
			};
			// For Pickup
			state.addDataItem = [];
			// For Shipout
			state.addShipoutData = [];
		},
	},
});

// Action creators are generated for each case reducer function
export const {
	handleAddDataItemReducer,
	setPartnerTypeList,
	setLockerTypeList,
	handleChangeLockerTypeAndUserTypeReducer,
	handleEditAddedDataReducer,
	setDoorSizesList,
	setPartnerDropoffFees,
	setPartnerShipoutFees,
	handleShipoutAddDataItemReducer,
	handleShipoutEditAddedDataReducer,
	handelCancelChagesReducer,
	handleEditDataReducer,
	handleShipoutEditDataReducer,
} = editPartnerFeeSlice.actions;

export default editPartnerFeeSlice.reducer;
